import {
  fromJS,
  Map as ImmutableMap,
  List as ImmutableList,
} from 'immutable'
import { STORE_HYDRATE } from '../actions/store'
import {
  MEDIA_ATTACHMENTS_EXPAND_REQUEST,
  MEDIA_ATTACHMENTS_EXPAND_SUCCESS,
  MEDIA_ATTACHMENTS_EXPAND_FAIL,
} from '../actions/media_attachments'
import { MEDIA_ATTACHMENTS_IMPORT } from '../actions/importer'

// source / type / ids
const initialState = ImmutableMap({
  accept_content_types: [],
  account: ImmutableMap(), // ids by account_id/type
  group: ImmutableMap(),
  chat_conversation: ImmutableMap(),
  items: ImmutableList(),
})

const importMediaAttachment = (state, mediaAttachment) => {
  return state.setIn(['items', `${mediaAttachment.id}`], fromJS(mediaAttachment))
}

const importMediaAttachments = (state, mediaAttachments) => {
  return state.withMutations((mutable) => mediaAttachments.forEach((mediaAttachment) => importMediaAttachment(mutable, mediaAttachment)))
}

const onRequest = (state, key, id, mediaType) => {
  const path = [key, id]
  if (!!mediaType) path.push(mediaType)

  // if deeply nested (i.e. with id) doesn't exist, setIn instead
  const exists = !!state.getIn(path, null)

  if (exists) {
    return state.updateIn(path, (map) => {
      return map
        .set('isLoading', true)
        .set('isFetched', false)
        .set('isError', false)
    })
  } else {
    return state.setIn(path, ImmutableMap({
      items: ImmutableList(),
      next: null,
      isLoading: true,
      isError: false,
      isFetched: false,
    }))
  }
}

const onSuccess = (state, key, id, mediaType, mediaAttachments, next) => {
  const path = [key, id]
  if (!!mediaType) path.push(mediaType)

  return state.updateIn(path, (map) => {
    return map
      .set('next', next)
      .set('isLoading', false)
      .set('isError', false)
      .set('isFetched', true)
      .update('items', (list) => {
        // if doesn't have any more to add, just return same
        if (!Array.isArray(mediaAttachments)) return list

        // unique
        let n = list.concat(mediaAttachments.map(item => `${item.id}`))
        n = Array.from(new Set(n))
        return fromJS(n)
      })
  })
}

const onFail = (state, key, id, mediaType) => {
  const path = [key, id]
  if (!!mediaType) path.push(mediaType)

  return state.updateIn([path], (map) => {
    return map
      .set('next', null)
      .set('items', ImmutableList())
      .set('isLoading', false)
      .set('isError', true)
      .set('isFetched', true)
  })
}

export default function meta(state = initialState, action) {
  switch(action.type) {
  case STORE_HYDRATE:
    return state
    // return state.setIn(['accept_content_types', action.state.get('media_attachments')])
  case MEDIA_ATTACHMENTS_IMPORT:
    return importMediaAttachments(state, action.mediaAttachments)

  case MEDIA_ATTACHMENTS_EXPAND_REQUEST:
    return onRequest(state, action.key, action.id, action.mediaType)
  case MEDIA_ATTACHMENTS_EXPAND_SUCCESS:
    return onSuccess(state, action.key, action.id, action.mediaType, action.mediaAttachments, action.next)
  case MEDIA_ATTACHMENTS_EXPAND_FAIL:
    return onFail(state, action.key, action.id, action.mediaType)
    
  default:
    return state
  }
}